module.exports = __webpack_public_path__ + "prod/20260406190927/img/logo_200.6488dd39.png";